const LONGITUD_EAN8 = 8
const LONGITUD_EAN13 = 13
const BASE_VERIFICADOR = 10
const MULTIPLICADOR_PAR_EAN13 = 1
const MULTIPLICADOR_IMPAR_EAN13 = 3
const MULTIPLICADOR_PAR_EAN8 = 3
const MULTIPLICADOR_IMPAR_EAN8 = 1
const MODULO_PARIDAD = 2
export const validarFormatoEAN = (ean) => {
  if (!ean) return false

  const str = String(ean).trim()

  if (str.length !== LONGITUD_EAN8 && str.length !== LONGITUD_EAN13) return false
  if (!/^\d+$/.test(str)) return false

  const digitos = str.split('').map(Number)
  const chequeaDigitos = digitos.pop()

  const isEAN13 = str.length === LONGITUD_EAN13
  const multiplicadorPar = isEAN13 ? MULTIPLICADOR_PAR_EAN13 : MULTIPLICADOR_PAR_EAN8
  const multiplicadorImpar = isEAN13 ? MULTIPLICADOR_IMPAR_EAN13 : MULTIPLICADOR_IMPAR_EAN8

  let suma = 0
  digitos.forEach((digito, index) => {
    const multiplicador = index % MODULO_PARIDAD === 0 ? multiplicadorPar : multiplicadorImpar
    suma += digito * multiplicador
  })

  const calculado = (BASE_VERIFICADOR - (suma % BASE_VERIFICADOR)) % BASE_VERIFICADOR
  return calculado === chequeaDigitos
}
